module.exports = __webpack_public_path__ + "static/media/come-to-free-the-words.f411fc3c.txt";